"use client";
import React, { useState } from 'react';
import PublicNav from '@/components/PublicNav';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import CategoryFilter, { FilterState } from './components/CategoryFilter';
import CauseGrid from './components/CauseGrid';
import GiftAidBanner from './components/GiftAidBanner';
import FeaturedCampaigns from './components/FeaturedCampaigns';
import BlogSection from './components/BlogSection';
import HomepageFooter from './components/HomepageFooter';
import CookieConsent from './components/CookieConsent';

const defaultFilters: FilterState = {
  search: '',
  category: 'all',
  urgency: 'all',
  location: 'All UK',
  sort: 'urgent',
};

export default function HomepagePage() {
  const [filters, setFilters] = useState<FilterState>(defaultFilters);
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicNav />
      <HeroSection />
      <StatsBar />
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-12">
        <CategoryFilter
          filters={filters}
          onFiltersChange={setFilters}
          showFilters={showFilters}
          onToggleFilters={() => setShowFilters((v) => !v)}
        />
        <CauseGrid filters={filters} />
        <GiftAidBanner />
        <FeaturedCampaigns />
        <BlogSection />
      </div>
      <HomepageFooter />
      <CookieConsent />
    </div>
  );
}